import { j as R } from "./jsx-runtime-3tyXYecC.mjs";
import * as S from "react";
import { forwardRef as Be } from "react";
import { f as q } from "./index-LyFokDcn.mjs";
import { h as y } from "./sizes-DktS74Qp.mjs";
import { c as K, o as Pe, m as Ee, b as Le } from "./tss-DN0acMKN.mjs";
import { M as le, d as se } from "./constants-CnFYFetN.mjs";
import { g as Oe, c as de } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { i as ue } from "./isHostComponent-kiaBvYVo.mjs";
import { f as Te } from "./formControlState-vgaj2ksH.mjs";
import { u as We, F as je } from "./useFormControl-C9UMlaFq.mjs";
import { g as $e } from "./index-BFVfkEeQ.mjs";
import { m as ge } from "./memoTheme-BzXKG_-k.mjs";
import { a as De } from "./utils-Bf5X_KZD.mjs";
import { g as Ne } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { s as he, u as Ue, c as Ge } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { u as Ke } from "./useForkRef-C_4o__cU.mjs";
import { u as Ve } from "./useEnhancedEffect-CJGo-L3B.mjs";
import { T as qe } from "./TextareaAutosize-CWylSdQ8.mjs";
function _e(e) {
  return Oe("MuiInputBase", e);
}
const V = Ne("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var ce;
const Je = (e, o) => {
  const {
    ownerState: t
  } = e;
  return [o.root, t.formControl && o.formControl, t.startAdornment && o.adornedStart, t.endAdornment && o.adornedEnd, t.error && o.error, t.size === "small" && o.sizeSmall, t.multiline && o.multiline, t.color && o[`color${K(t.color)}`], t.fullWidth && o.fullWidth, t.hiddenLabel && o.hiddenLabel];
}, Qe = (e, o) => {
  const {
    ownerState: t
  } = e;
  return [o.input, t.size === "small" && o.inputSizeSmall, t.multiline && o.inputMultiline, t.type === "search" && o.inputTypeSearch, t.startAdornment && o.inputAdornedStart, t.endAdornment && o.inputAdornedEnd, t.hiddenLabel && o.inputHiddenLabel];
}, Xe = (e) => {
  const {
    classes: o,
    color: t,
    disabled: n,
    error: r,
    endAdornment: i,
    focused: s,
    formControl: u,
    fullWidth: c,
    hiddenLabel: g,
    multiline: h,
    readOnly: C,
    size: m,
    startAdornment: d,
    type: z
  } = e, A = {
    root: ["root", `color${K(t)}`, n && "disabled", r && "error", c && "fullWidth", s && "focused", u && "formControl", m && m !== "medium" && `size${K(m)}`, h && "multiline", d && "adornedStart", i && "adornedEnd", g && "hiddenLabel", C && "readOnly"],
    input: ["input", n && "disabled", z === "search" && "inputTypeSearch", h && "inputMultiline", m === "small" && "inputSizeSmall", g && "inputHiddenLabel", d && "inputAdornedStart", i && "inputAdornedEnd", C && "readOnly"]
  };
  return Ge(A, _e, o);
}, Ye = he("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: Je
})(ge(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${V.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: o
    }) => o.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: o,
      size: t
    }) => o.multiline && t === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: o
    }) => o.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), Ze = he("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Qe
})(ge(({
  theme: e
}) => {
  const o = e.palette.mode === "light", t = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: o ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, n = {
    opacity: "0 !important"
  }, r = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: o ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": t,
    "&::-moz-placeholder": t,
    // Firefox 19+
    "&::-ms-input-placeholder": t,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${V.formControl} &`]: {
      "&::-webkit-input-placeholder": n,
      "&::-moz-placeholder": n,
      // Firefox 19+
      "&::-ms-input-placeholder": n,
      // Edge
      "&:focus::-webkit-input-placeholder": r,
      "&:focus::-moz-placeholder": r,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": r
      // Edge
    },
    [`&.${V.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: i
      }) => i.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), pe = $e({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), eo = /* @__PURE__ */ S.forwardRef(function(o, t) {
  const n = Ue({
    props: o,
    name: "MuiInputBase"
  }), {
    "aria-describedby": r,
    autoComplete: i,
    autoFocus: s,
    className: u,
    color: c,
    components: g = {},
    componentsProps: h = {},
    defaultValue: C,
    disabled: m,
    disableInjectingGlobalStyles: d,
    endAdornment: z,
    error: A,
    fullWidth: v = !1,
    id: b,
    inputComponent: w = "input",
    inputProps: p = {},
    inputRef: F,
    margin: E,
    maxRows: be,
    minRows: Se,
    multiline: _ = !1,
    name: ye,
    onBlur: H,
    onChange: J,
    onClick: Q,
    onFocus: X,
    onKeyDown: xe,
    onKeyUp: Ce,
    placeholder: ze,
    readOnly: L,
    renderSuffix: Y,
    rows: B,
    size: so,
    slotProps: Z = {},
    slots: ee = {},
    startAdornment: M,
    type: oe = "text",
    value: ve,
    ...Ae
  } = n, P = p.value != null ? p.value : ve, {
    current: O
  } = S.useRef(P != null), I = S.useRef(), Ie = S.useCallback((a) => {
  }, []), Re = Ke(I, F, p.ref, Ie), [T, W] = S.useState(!1), l = We(), f = Te({
    props: n,
    muiFormControl: l,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  f.focused = l ? l.focused : T, S.useEffect(() => {
    !l && m && T && (W(!1), H && H());
  }, [l, m, T, H]);
  const j = l && l.onFilled, $ = l && l.onEmpty, k = S.useCallback((a) => {
    De(a) ? j && j() : $ && $();
  }, [j, $]);
  Ve(() => {
    O && k({
      value: P
    });
  }, [P, k, O]);
  const we = (a) => {
    X && X(a), p.onFocus && p.onFocus(a), l && l.onFocus ? l.onFocus(a) : W(!0);
  }, He = (a) => {
    H && H(a), p.onBlur && p.onBlur(a), l && l.onBlur ? l.onBlur(a) : W(!1);
  }, Me = (a, ...re) => {
    if (!O) {
      const ae = a.target || I.current;
      if (ae == null)
        throw new Error(Pe(1));
      k({
        value: ae.value
      });
    }
    p.onChange && p.onChange(a, ...re), J && J(a, ...re);
  };
  S.useEffect(() => {
    k(I.current);
  }, []);
  const ke = (a) => {
    I.current && a.currentTarget === a.target && I.current.focus(), Q && Q(a);
  };
  let D = w, x = p;
  _ && D === "input" && (B ? x = {
    type: void 0,
    minRows: B,
    maxRows: B,
    ...x
  } : x = {
    type: void 0,
    maxRows: be,
    minRows: Se,
    ...x
  }, D = qe);
  const Fe = (a) => {
    k(a.animationName === "mui-auto-fill-cancel" ? I.current : {
      value: "x"
    });
  };
  S.useEffect(() => {
    l && l.setAdornedStart(!!M);
  }, [l, M]);
  const N = {
    ...n,
    color: f.color || "primary",
    disabled: f.disabled,
    endAdornment: z,
    error: f.error,
    focused: f.focused,
    formControl: l,
    fullWidth: v,
    hiddenLabel: f.hiddenLabel,
    multiline: _,
    size: f.size,
    startAdornment: M,
    type: oe
  }, te = Xe(N), ne = ee.root || g.Root || Ye, U = Z.root || h.root || {}, ie = ee.input || g.Input || Ze;
  return x = {
    ...x,
    ...Z.input ?? h.input
  }, /* @__PURE__ */ R.jsxs(S.Fragment, {
    children: [!d && typeof pe == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (ce || (ce = /* @__PURE__ */ R.jsx(pe, {}))), /* @__PURE__ */ R.jsxs(ne, {
      ...U,
      ref: t,
      onClick: ke,
      ...Ae,
      ...!ue(ne) && {
        ownerState: {
          ...N,
          ...U.ownerState
        }
      },
      className: de(te.root, U.className, u, L && "MuiInputBase-readOnly"),
      children: [M, /* @__PURE__ */ R.jsx(je.Provider, {
        value: null,
        children: /* @__PURE__ */ R.jsx(ie, {
          "aria-invalid": f.error,
          "aria-describedby": r,
          autoComplete: i,
          autoFocus: s,
          defaultValue: C,
          disabled: f.disabled,
          id: b,
          onAnimationStart: Fe,
          name: ye,
          placeholder: ze,
          readOnly: L,
          required: f.required,
          rows: B,
          value: P,
          onKeyDown: xe,
          onKeyUp: Ce,
          type: oe,
          ...x,
          ...!ue(ie) && {
            as: D,
            ownerState: {
              ...N,
              ...x.ownerState
            }
          },
          ref: Re,
          className: de(te.input, x.className, L && "MuiInputBase-readOnly"),
          onBlur: He,
          onChange: Me,
          onFocus: we
        })
      }), z, Y ? Y({
        ...f,
        startAdornment: M
      }) : null]
    })]
  });
}), oo = 1.25, G = {
  teenie: 28,
  small: 32,
  medium: 34,
  large: 36,
  biggie: 42
}, me = {
  teenie: 0.875,
  small: 0.9375,
  medium: 0.625,
  large: 0.625,
  biggie: 1.315
}, to = ({ mixins: e, palette: o }, { disabled: t, status: n, viewMode: r }) => t ? e.border(1, o.grey[300]) : n ? e.border(1, e.fieldStatusColor(n, o)) : r ? e.border(1, o.grey[300]) : e.border(1, o.grey[400]), no = ({ mixins: e, palette: o }, { classes: t, disabled: n, viewMode: r = !1 }) => t && "focused" in t ? {
  border: !n && !status && r ? e.border(1, o.grey[400]) : void 0
} : {
  border: !n && !status && r ? e.border(1, o.grey[400]) : void 0,
  boxShadow: n ? "none" : "0 1px 0 0 rgba(0, 0, 0, 0.05)"
}, fe = (e, {
  classes: o,
  disabled: t,
  status: n,
  focusRing: r = !0,
  viewMode: i
}) => {
  const { constructs: s, mixins: u, palette: c } = e;
  return r ? o && "focused" in o ? {} : q.ifFeature(
    "encore",
    {
      ...u.inputOutline(e, { disabled: t, focused: !0, status: n, viewMode: i }),
      "&>.MuiInputAdornment-root": {
        fill: u.fieldStatusColor(n, c, s.icon.primary.medium)
      }
    },
    {
      boxShadow: `${Le(u.fieldStatusColor(n, c, c.primary.lighter), 0.25)} 0 0 0 2px`,
      borderColor: u.fieldStatusColor(n, c, c.primary.lighter),
      "&>.MuiInputAdornment-root": {
        fill: c.primary.main
      }
    }
  ) : {};
}, io = ({ typography: e }, o) => {
  var t, n, r, i;
  return {
    teenie: {
      fontSize: (t = e.small) == null ? void 0 : t.fontSize,
      lineHeight: (n = e.small) == null ? void 0 : n.lineHeight,
      maxHeight: o ? "unset" : y.teenie,
      minHeight: y.teenie
    },
    small: {
      fontSize: (r = e.small) == null ? void 0 : r.fontSize,
      lineHeight: (i = e.small) == null ? void 0 : i.lineHeight,
      maxHeight: o ? "unset" : y.small,
      minHeight: y.small
    },
    medium: {
      fontSize: e.medium.fontSize,
      lineHeight: e.medium.lineHeight,
      maxHeight: o ? "unset" : y.medium,
      minHeight: y.medium
    },
    large: {
      fontSize: e.large.fontSize,
      lineHeight: e.large.lineHeight,
      maxHeight: o ? "unset" : y.large,
      minHeight: y.large
    },
    biggie: {
      fontSize: e.large.fontSize,
      lineHeight: e.large.lineHeight,
      maxHeight: o ? "unset" : y.biggie,
      minHeight: y.biggie
    }
  };
}, ro = (e, o) => {
  const { borderRadiuses: t } = e, { multiline: n, size: r } = o;
  return n ? t[{
    teenie: 400,
    small: 400,
    medium: 500,
    large: 600,
    biggie: 600
  }[r]] : t[1e3];
}, ao = Ee()((e, o) => {
  var F, E;
  const { borderRadiuses: t, mixins: n, mode: r, palette: i, spacing: s, transitions: u, typography: c } = e, { denseAdornment: g, disabled: h, endAdornment: C, multiline: m, size: d, startAdornment: z, status: A, variant: v, viewMode: b } = o, w = () => v === "single" ? z ? 1 : 2 : z ? 1 : 1.5, p = () => s(v === "single" ? 2 : 1.5);
  return q.ifFeature(
    "encore",
    {
      root: {
        backgroundColor: h ? i.gray[50] : i.common.white,
        borderRadius: v === "single" ? ro(e, o) : t[200],
        ...n.inputOutline(e, { disabled: h, status: A, viewMode: b }),
        outline: r === le.Dye ? `1px solid ${se.main}` : void 0,
        // when multiline, on Chrome on Mac with scroll bars always showing, scroll bar overflows corners without this
        // we only apply to multiline because it can cause issues in other contexts where we want overflow,
        // such as cutting off the focus ring of a button at the end of the input
        overflow: m ? "clip" : void 0,
        // this handles the scrollbar overflow; clip causes issues when not multiline
        padding: 0,
        transition: u.create(["border", "box-shadow"]),
        "&:hover": {
          ...n.inputOutline(e, { disabled: h, focused: !1, hover: !0, status: A, viewMode: b })
        },
        "&:focus, &:focus-within": fe(e, o),
        "&>.MuiInputAdornment-root": {
          fill: i.gray[800],
          flexShrink: 0,
          transition: u.create(["fill"])
        },
        "&>.MuiInputAdornment-positionEnd": {
          paddingRight: g ? 0 : s(2),
          margin: 0,
          // make border of button line up with border of input
          position: "relative",
          right: -1
        },
        "&>.MuiInputAdornment-positionStart": {
          paddingLeft: g ? 0 : p(),
          margin: 0,
          // make border of button line up with border of input
          position: "relative",
          left: -1
        }
      },
      denseAdornment: {},
      input: {
        color: i.gray[800],
        height: "100%",
        padding: s(1, C ? 1 : 2, 1, w()),
        position: "relative",
        "&::placeholder": {
          color: i.gray[600],
          opacity: 1
        },
        "&.Mui-disabled": {
          color: i.gray[600],
          WebkitTextFillColor: "unset",
          "&::placeholder": {
            color: i.gray[600],
            opacity: 1
          }
        }
      },
      size: {
        ...io(e, m)[d]
      },
      focused: {}
    },
    {
      root: {
        backgroundColor: i.common.white,
        borderRadius: 2,
        border: to(e, o),
        outline: r === le.Dye ? `1px solid ${se.main}` : void 0,
        transition: u.create(["all"]),
        "&:hover": no(e, o),
        "&:focus-within": fe(e, o),
        "&>.MuiInputAdornment-root": {
          backgroundColor: i.gray[100],
          height: G[d] - 2,
          padding: s(0, ["large", "biggie"].includes(d) ? 1 : 0.75),
          justifyContent: "center",
          maxHeight: "unset",
          fill: i.gray[600]
        },
        "&>.MuiInputAdornment-positionEnd": {
          margin: 0
        },
        "&>.MuiInputAdornment-positionStart": {
          margin: 0
        }
      },
      denseAdornment: {
        "&.MuiInputBase-root>.MuiInputAdornment-root": {
          padding: 0
        }
      },
      input: {
        boxSizing: "border-box",
        height: "unset",
        position: "relative",
        paddingLeft: s(oo)
      },
      size: {
        fontSize: (F = c[d]) == null ? void 0 : F.fontSize,
        lineHeight: (E = c[d]) == null ? void 0 : E.lineHeight,
        minHeight: G[d],
        maxHeight: m ? "unset" : G[d],
        paddingTop: s(me[d]),
        paddingBottom: s(me[d])
      },
      focused: {
        // Needs to be implemented so we can pass it through
      }
    }
  );
}), lo = Be((e, o) => {
  const { classname: t, className: n, sx: r, ...i } = e, s = q.ifFeature("encore", i, e), {
    ariaLabel: u,
    biId: c,
    denseAdornment: g,
    focusRing: h,
    inputProps: C = {},
    size: m = "medium",
    status: d,
    variant: z = "form",
    viewMode: A,
    ...v
  } = s, { classes: b, cx: w } = ao(s, { props: { classes: s.classes } }), p = {
    "aria-label": u,
    type: "text",
    ...C,
    "data-bi-id": c
  };
  return /* @__PURE__ */ R.jsx(
    eo,
    {
      ...v,
      classes: {
        root: w(b.root, b.size, { [b.denseAdornment]: g }),
        focused: b.focused,
        input: b.input
      },
      error: d === "error",
      inputProps: p,
      inputRef: o
    }
  );
});
lo.defaultProps = {
  size: "medium"
};
export {
  eo as I,
  lo as O,
  V as i
};
//# sourceMappingURL=outlined-input-wBBzs904.mjs.map
